/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_StorageInputs */

const en_us2_body_assessment_consent_storage = /** @type {(inputs: Body_Assessment_Consent_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The photos are kept in private storage, reachable only by your account, until you delete the assessment, withdraw this permission or delete your account.`)
};

const pt_br2_body_assessment_consent_storage = /** @type {(inputs: Body_Assessment_Consent_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fotos ficam guardadas em armazenamento privado, acessível só pela sua conta, até você apagar a avaliação, revogar esta autorização ou apagar a conta.`)
};

const es_419_body_assessment_consent_storage = /** @type {(inputs: Body_Assessment_Consent_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fotos se guardan en un almacenamiento privado, al que solo tu cuenta tiene acceso, hasta que borres la evaluación, retires este permiso o elimines tu cuenta.`)
};

const pt_pt2_body_assessment_consent_storage = /** @type {(inputs: Body_Assessment_Consent_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fotos ficam guardadas em armazenamento privado, acessível apenas pela tua conta, até apagares a avaliação, revogares esta autorização ou apagares a conta.`)
};

const fr_fr2_body_assessment_consent_storage = /** @type {(inputs: Body_Assessment_Consent_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les photos sont conservées dans un stockage privé, accessible uniquement par ton compte, jusqu'à ce que tu supprimes l'évaluation, retires cette autorisation ou supprimes ton compte.`)
};

const de_de2_body_assessment_consent_storage = /** @type {(inputs: Body_Assessment_Consent_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Fotos liegen in privatem Speicher, nur für dein Konto erreichbar, bis du die Messung löschst, diese Erlaubnis widerrufst oder dein Konto löschst.`)
};

const it_it2_body_assessment_consent_storage = /** @type {(inputs: Body_Assessment_Consent_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le foto restano in uno spazio privato, accessibile solo dal tuo account, finché non elimini la valutazione, revochi questo consenso o elimini l'account.`)
};

/**
* | output |
* | --- |
* | "The photos are kept in private storage, reachable only by your account, until you delete the assessment, withdraw this permission or delete your account." |
*
* @param {Body_Assessment_Consent_StorageInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_storage = /** @type {((inputs?: Body_Assessment_Consent_StorageInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_StorageInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_storage(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_storage(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_storage(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_storage(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_storage(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_storage(inputs)
	return en_us2_body_assessment_consent_storage(inputs)
});
export { body_assessment_consent_storage as "body-assessment.consent_storage" }